<template>
  <div :class="{ isShow: control }" class="commonVideo">
    <!-- {{ videoState }} -->
    <video
      ref="myVideo"
      :poster="posterImgVal"
      :src="src"
      :controls="isShowControl"
      :autoplay="autoplay"
      :loop="loop"
      oncontextmenu="return false"
      @timeupdate="timeupdate"
      controlslist="nodownload"
      class="video-box"
    ></video>
    <div v-if="!isShowControl" @click.stop="operateVideo" class="operateBtn" :class="{ 'fade-out': videoState }">
      <div class="iconBox"><van-icon name="play-circle" color="#fff" size="40" v-if="!videoState" /></div>
    </div>
    <!-- <img v-if="showPosterImg" :src="myPosterImg" alt="" srcset="" /> -->
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watch, nextTick, ref, onUnmounted, computed } from 'vue'
import _ from 'lodash'

export default {
  name: 'CommonVideo',
  /**
   * @param poster 展示图
   * @param src 视频资源
   * @param isShowControl 是否显示控件
   * @param control 控件控制
   * @param videoData 视频基础数据
   */
  props: {
    poster: {
      type: String,
      required: false,
      default: ''
    },
    src: {
      type: String,
      required: true
    },
    isShowControl: {
      type: Boolean,
      required: false,
      default: true
    },
    control: {
      type: Boolean,
      required: false,
      default: false
    },
    videoData: {
      type: Object,
      required: true
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: false
    },
    loop: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props, { emit }) {
    let { poster, src, isShowControl, control, videoData, autoplay, loop } = toRefs(props)
    const myVideo = ref()
    const state = reactive({
      poster,
      src,
      isShowControl,
      control,
      videoData,
      autoplay,
      loop,
      // 视频播放状态
      videoState: !!autoplay,
      // 学时
      studyTime: {
        currentTime: 0, // 当前已学时长
        duration: 0 // 总时长
      },
      isFirst: true,
      timer: {}, // 定时器
      pauseTimer: {}, // 暂停定时器
      showPosterImg: false,
      myPosterImg: ''
    })
    // 开启定时器
    const openTimer = () => {
      console.log('openTimer-----')
      state.timer = setInterval(() => {
        emit('videoStudyTime', state.studyTime)
      }, 5000)
    }
    // 关闭定时器
    const closeTimer = () => {
      console.log('closeTimer-----')
      clearInterval(state.timer)
      emit('videoStudyTime', state.studyTime)
    }
    // 开启暂停定时器
    const openPauseTimer = () => {
      state.pauseTimer = setInterval(() => {
        state.hintOperate()
      }, 600000)
    }
    // 关闭暂停定时器
    const closePauseTimer = () => {
      clearInterval(state.pauseTimer)
    }
    // 提示操作
    const hintOperate = () => {
      // operateVideo()
      // this.$alert("请点击确认继续学习", "提示", {
      //   confirmButtonText: "确定",
      //   confirmButtonClass: "hint-btn",
      //   showClose: false,
      //   callback: action => {
      //     this.$refs.myVideo.currentTime = this.videoData.currentTime;
      //     this.operateVideo();
      //     this.openPauseTimer();
      //   }
      // });
      myVideo.value.currentTime = state.videoData.currentTime
      operateVideo()
      openPauseTimer()
    }
    // 获取当前播放位置
    const timeupdate = e => {
      state.studyTime.currentTime = e.target.currentTime
      state.studyTime.duration = e.target.duration ? e.target.duration : 0
      // console.log('timeupdate', state.studyTime)
      // _.debounce(() => {
      //   emit('timeupdate', state.studyTime)
      // }, 300)
    }
    const playVideo = () => {
      myVideo.value.play()
      state.videoState = true
      state.isFirst = false
    }
    // 操作视频播放、暂停
    const operateVideo = () => {
      console.log('operateVideo', state.videoState)
      if (!state.src) {
        // this.$message({ message: "暂无视频资源，请查看其他视频！" });
        console.log('暂无视频资源，请查看其他视频！')
        return false
      }
      if (myVideo.value.paused) {
        playVideo()
      } else {
        myVideo.value.pause()
        state.videoState = false
      }
    }
    const setMedia = (video, scale = 0.8) => {
      video.addEventListener('loadeddata', e => {
        console.log('setMedia--start1', video)
        video.currentTime = 1
        setTimeout(() => {
          // let canvas = document.createElement('canvas')
          // let ctx = canvas.getContext('2d')
          // canvas.width = video.videoWidth * scale
          // canvas.height = video.videoHeight * scale
          // ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
          // let src = canvas.toDataURL('image/png')
          // console.log('setMedia--src', src)
          // state.myPosterImg = src
          video.currentTime = 0
        }, 800)
      })
    }
    let posterImgVal = computed(() => {
      return state.myPosterImg || state.poster || ''
    })

    onMounted(async () => {
      console.log('addEventListener', myVideo)
      // 监听视频播放
      myVideo.value.addEventListener('play', openTimer)
      // 监听视频暂停
      myVideo.value.addEventListener('pause', closeTimer)
      myVideo.value.addEventListener('canplay', function(e) {
        console.log('canplay------------提示该视频已准备好开始播放')
        // console.log(e)
        // myVideo.value.play()
        // state.videoState = true
        // try {
        //   console.log('canplay------------setMedia')
        //   setMedia(myVideo.value)
        // } catch (error) {
        //   console.log('setMedia-error', error)
        // }
      })
      try {
        setMedia(myVideo.value)
      } catch (error) {
        console.log('setMedia-error', error)
      }
    })
    watch(
      () => videoData,
      (val, oldVal) => {
        const { currentTime, duration } = val
        if (currentTime && duration && currentTime < duration) {
          hintOperate()
        }
      }
    )
    // 离开页面清除轮询
    onUnmounted(() => {
      closePauseTimer
    })
    return {
      ...toRefs(state),
      myVideo,
      operateVideo,
      timeupdate,
      playVideo,
      posterImgVal
    }
  }
}
</script>

<style lang="scss" scoped>
.commonVideo {
  position: relative;
  .video-box {
    box-sizing: border-box;
    border: 0;
    display: block;
    width: 100%;
    height: 100%;
    outline: none !important;
  }
  .isShow {
    //进度条
    video::-webkit-media-controls-timeline {
      display: none;
    }
  }
  video::-webkit-media-controls-play-button {
    visibility: hidden;
  }
  .operateBtn {
    display: block;
    width: 100%;
    height: calc(100% - 40px);
    position: absolute;
    // top: calc(50% - 80px);
    // left: calc(50% - 100px);
    left: 0;
    top: 0;
    z-index: 9999999;
    text-align: center;
    // border: 1px solid red;
  }
  .operateBtn .iconBox {
    position: absolute;
    top: calc(50% - 40px);
    left: calc(50% - 50px);
    width: 100px;
    height: 100px;
    line-height: 100px;
    // border: 1px solid blue;
  }
  .operateBtn:hover {
    opacity: 0.8;
  }
  .fade-out {
    opacity: 0;
  }
}
</style>
